<uni-snackbar-item
  *ngFor="let snackbar of snackbars$ | async"
  [snackbar]="snackbar"
></uni-snackbar-item>
